import React from 'react';
import { Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import {
  StockTransferListDestinationPage,
  StockTransferListSourcePage,
} from 'pages/stock-transfer/stock-transfer-list';
import { StockTransferSummaryPage } from 'pages/stock-transfer/stock-transfer-summary';
import {
  StockTransferTaskDestinationPage,
  StockTransferTaskSourcePage,
} from 'pages/stock-transfer/stock-transfer-task';

import { STOCK_TRANSFER_ROUTES } from './constants/stock-transfer-routes.constant';

export const useStockTransferRouter = (): React.JSX.Element => (
  <Route
    path={STOCK_TRANSFER_ROUTES.STOCK_TRANSFER}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.ADMIN,
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.REPLENISH,
        ]}
      />
    }
  >
    <Route
      path={STOCK_TRANSFER_ROUTES.LIST_SOURCE}
      element={<StockTransferListSourcePage />}
    />
    <Route
      path={STOCK_TRANSFER_ROUTES.TASK_SOURCE}
      element={<StockTransferTaskSourcePage />}
    />
    <Route
      path={STOCK_TRANSFER_ROUTES.LIST_DESTINATION}
      element={<StockTransferListDestinationPage />}
    />
    <Route
      path={STOCK_TRANSFER_ROUTES.TASK_DESTINATION}
      element={<StockTransferTaskDestinationPage />}
    />
    <Route
      path={STOCK_TRANSFER_ROUTES.SUMMARY}
      element={<StockTransferSummaryPage />}
    />
  </Route>
);
